import { c as _c } from "react/compiler-runtime";
import React, { ChangeEvent, KeyboardEvent, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNum } from '@/utils/formatting';
import { mergeClasses } from '@/utils/style';
type Props = {
  value: number;
  max: number;
  min: number;
  name: string;
  onBlur: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (e: KeyboardEvent<HTMLInputElement>) => void;
  withCurrency?: boolean;
};
export function CalculatorNumberInput(props) {
  const $ = _c(33);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t,
    i18n
  } = useTranslation(t0);
  let t1;
  if ($[1] !== props.value) {
    t1 = props.value.toString();
    $[1] = props.value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [value, setValue] = useState(t1);
  let t2;
  if ($[3] !== i18n.language) {
    t2 = inputValue => formatNum(inputValue, undefined, i18n.language)?.replace(/\u00A0/g, " ") ?? inputValue.toString();
    $[3] = i18n.language;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formatValue = t2;
  const sanitizeValue = _temp;
  let t3;
  if ($[5] !== props.max || $[6] !== props.min) {
    t3 = inputValue_1 => {
      const sanitizedValue = sanitizeValue(inputValue_1);
      const parsedValue = parseFloat(sanitizedValue);
      const nextValue = isNaN(parsedValue) ? props.min : Math.min(Math.max(Math.ceil(parsedValue), props.min), props.max);
      return nextValue.toString();
    };
    $[5] = props.max;
    $[6] = props.min;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const normalizeValue = t3;
  let t4;
  let t5;
  if ($[8] !== formatValue || $[9] !== props.value) {
    t4 = () => {
      setValue(formatValue(props.value));
    };
    t5 = [formatValue, props.value];
    $[8] = formatValue;
    $[9] = props.value;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setValue(sanitizeValue(e.target.value));
    t7 = e_0 => setValue(sanitizeValue(e_0.target.value));
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] !== formatValue || $[15] !== normalizeValue || $[16] !== props) {
    t8 = e_1 => {
      const normalizedValue = normalizeValue(e_1.currentTarget.value);
      e_1.currentTarget.value = normalizedValue;
      props.onBlur(e_1);
      setValue(formatValue(normalizedValue));
    };
    t9 = e_2 => {
      if (e_2.key === "Enter") {
        const normalizedValue_0 = normalizeValue(e_2.currentTarget.value);
        e_2.currentTarget.value = normalizedValue_0;
        setValue(formatValue(normalizedValue_0));
      } else {
        e_2.currentTarget.value = sanitizeValue(e_2.currentTarget.value);
      }
      props.onKeyPress(e_2);
    };
    $[14] = formatValue;
    $[15] = normalizeValue;
    $[16] = props;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  const t10 = props.withCurrency ? "w-28 pr-10 md:w-30 md:pr-11" : "w-15 pr-4 md:pr-5";
  let t11;
  if ($[19] !== t10) {
    t11 = mergeClasses("w-28 [appearance:textfield] rounded-lg border border-blue-500 bg-white py-2 pl-4 text-right text-base font-medium text-gray-900 md:py-3 md:pl-5 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none", t10);
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== props || $[22] !== t11 || $[23] !== t8 || $[24] !== t9 || $[25] !== value) {
    t12 = <input {...props} value={value} onChange={t6} onFocus={t7} onBlur={t8} onKeyPress={t9} type="text" inputMode="numeric" pattern="[0-9 ]*" className={t11} />;
    $[21] = props;
    $[22] = t11;
    $[23] = t8;
    $[24] = t9;
    $[25] = value;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== props.withCurrency || $[28] !== t) {
    t13 = props.withCurrency && <span className="absolute top-1/2 right-4 z-10 inline-block -translate-y-1/2 text-base font-medium text-gray-900 md:right-5">{t("core:currency")}</span>;
    $[27] = props.withCurrency;
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className="relative inline-block">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}
function _temp(inputValue_0) {
  return inputValue_0.replace(/[^\d]/g, "");
}